/*global jQuery:false */
'use strict';

var markers = [];
var map;
var emptyBounds;
var isMapLoaded = false;

// Deletes all markers in the array by removing references to them.
function deleteMarkers() {
    for (let i = 0; i < markers.length; i++) {
        if (!!markers[i]) {
            markers[i].map = null;
        }
    }
    markers = [];
    isMapLoaded = false;
}

function clickMarkerById(id) {
    google.maps.event.trigger(markers[id], 'click');
}

var initializeMap = function () {
    emptyBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(44.2645829, -78.812466),
        new google.maps.LatLng(50.7331204, -63.8576864));

    // Make our markers
    var montreal = {
        lat: 45.516672,
        lng: -73.650005
    };

    map = new google.maps.Map(document.getElementById('search-map-container'), {
        zoom: 13,
        center: montreal,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        panControl: false
    });

    map.fitBounds(emptyBounds);
    if (isMapLoaded) {
        displayMarkers();
    } else {
        map.addListener('tilesloaded', displayMarkers);
    }
};

function displayMarkers() {
    if (!isMapLoaded) {
        let iconPin
        let iconPinFavorite
        let iconPinSize
        let iconPinFavoriteSize
        if ($('body').hasClass('loyalty-FB')) {
            iconPin = "/images/shared/small/icons/icon-pin.png";
            iconPinFavorite = "/images/shared/small/icons/icon-pin-star.png"
            iconPinSize = new google.maps.Size(30, 30)
            iconPinFavoriteSize = new google.maps.Size(39, 44)
        } else {
            iconPin = "/images/shared/pin-map--superc.png";
            iconPinFavorite = "/images/shared/pin-map--superc-favorite.png"
            iconPinSize = new google.maps.Size(30, 40)
            iconPinFavoriteSize = new google.maps.Size(39, 51)
        };
        isMapLoaded = true;
        var bounds = new google.maps.LatLngBounds();
        var count = 0;
        var infoWindow = new google.maps.InfoWindow();

        var iconNormal = {
            url: iconPin,
            scaledSize: iconPinSize,
            labelOrigin: new google.maps.Point(13, 17)
        };
        var iconFavorite = {
            url: iconPinFavorite,
            scaledSize: iconPinFavoriteSize,
            labelOrigin: new google.maps.Point(13, 21)
        };

        jQuery(".find-a-store .fs--box-shop").each(
            function (index, node) {
                count = count + 1;
                var $node = jQuery(node);
                var storeName = $node.data('store-name');
                var iconImageName = $node.data('name-image');
                var image = iconImageName === 'pin-map--superc.png' ? iconNormal : iconFavorite;
                var latitude = parseFloat($node.data('store-lat'));
                var longitude = parseFloat($node.data('store-lng'));
                var storeId = $node.data('store-id');

                createMarker(map, image, latitude, longitude, storeName, storeId, bounds, infoWindow);
            });

        let $container = $('#search-map-container');
        $container.on('click', '.setMyStoreButton', onClickSetMyStore);
        $container.on('click', '.fs--grocery-detail', onClickDetailsStore);
        $container.on('click', '.setMyCommunicationStoreButton', onClickConfirmMyCommunicationStore);

        if (bounds.isEmpty()) {
            map.fitBounds(emptyBounds);
        } else {
            map.fitBounds(bounds);
            if (markers.length === 1) {
                map.setZoom(16);
            }
        }
    }
}

function onClickDetailsStore() {
    pushDataLayerStoreClick('carte-details-du-magasin');
}

function createMarker(map, image, latitude, longitude, storeName, storeId, bounds, infoWindow) {
    var marker = new google.maps.Marker({
        position: {
            lat: latitude,
            lng: longitude
        },
        map: map,
        title: storeName,
        optimized: false,

        icon: image
    });

    bounds.extend(marker.position);

    marker.addListener('click', function () {
        $.ajax({
            url: findStoreUrl + '/storeDetails/' + storeId,
            type: "PATCH",
            headers: {
                "Accept-Language": lang
            },
            async: false,
            contentType: "application/json; charset=utf-8",
            success: _updateInfoWindowAjaxResponse.bind(infoWindow),
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    _updateInfoWindowAjaxResponse.bind(infoWindow);
                }
            }
        });

        infoWindow.open(map, marker);
        pushDataLayerStoreClick('clic-localisateur-carte');
    });
    markers.push(marker);
}

function _updateInfoWindowAjaxResponse(data) {
    this.setContent(data + "");
}

function hideMapPlaceholderToDisplayMap() {
    $('#search-all-stores-map-placeholder').hide();
    $('#search-map-container').removeClass('fs--hide').addClass('standalone-map');
    $('.fs--boxes-shops').removeClass('hide');
    $('.fs--box-shop').hide();
    $('.showMoreStores').hide();
    $('.find-a-store .fs--boxes').show();
}

function showMapPlaceholderToDisplayMap() {
    $('#search-all-stores-map-placeholder').show();
    $('#search-map-container').addClass('fs--hide').removeClass('standalone-map').empty();
    $('.fs--boxes-shops').addClass('hide');
    $('.fs--box-shop').show();
    $('.showMoreStores').show();
    $('.fs--boxes').hide();
}

function initFindStore() {
    const fsContainerId = '.find-a-store';
    const fsBoxesShops = fsContainerId + ' .fs--boxes-shops';
    const fsSearchForm = fsContainerId + ' #searchForm';
    const fsPostalCode = fsContainerId + ' #postalCode';
    const fsCityHidden = fsContainerId + ' .city-hidden';
    const fsMapResults = fsContainerId + ' #mapResults'
    var $form = $(fsSearchForm);
    let $dropDownCityFinder = $('.openCity');

    $form.find('input[name=postalCode]').on('input', function () {
        $dropDownCityFinder.text($dropDownCityFinder.attr('data-initial-text'));
        $('#city').val('');
    });

    var sectionInProgress = $('.internal.vitrine');
    $form.submit(function (e) {
        e.preventDefault();
        $('#error-summary').html('');
        sectionInProgress.addClass('in-progress relative');

        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            success: function (data) {
                deleteMarkers();

                var html = $(data);

                $form.find('input').blur();

                $('#nbResultsFound').replaceWith(html.find('#nbResultsFound'));
                $('#nbResultsFound').removeClass('hide').attr('tabindex', '-1').focus();
                $('#error-summary').html(html.find('#error-summary').html());

                if (html.find(fsMapResults).length > 0) {
                    hideMapPlaceholderToDisplayMap();
                    $('#search-map-container').removeClass('fs--landing--map').addClass('fs--search--map');
                    $(fsBoxesShops).css('visibility', 'visible');
                    $(fsBoxesShops).replaceWith(html.find(fsMapResults)[0].outerHTML);
                    $('#mobileListOrMap').removeClass('hide');
                    if ($(fsPostalCode).val() != '' || $(fsCityHidden).val() != '') {
                        initializeMap();
                        onClickBoxShowMapMarker();


                        if ($dropDownCityFinder.attr('aria-expanded') === "true") {
                            $dropDownCityFinder.removeClass('active');
                            $dropDownCityFinder.attr('aria-expanded', false);
                            $('.fs--location-container').hide();
                        }
                    }

                    $('.showMoreStores').on('click', function () {
                        $('#mapResults .fs--box-shop').fadeIn();
                        $(this).fadeOut();
                    });
                } else {
                    $('#search-map-container').removeClass('fs--search--map').addClass('fs--landing--map');
                    $(fsBoxesShops).hide();
                    showMapPlaceholderToDisplayMap();
                }

                injectSVG();
                pushDataLayerSearchStore();
                $('.setMyStoreButton').click(onClickSetMyStore);
                $('.fs--grocery-detail').click(onClickDetailsStore);
                $('.setMyCommunicationStoreButton').click(onClickConfirmMyCommunicationStore);
                sectionInProgress.removeClass('in-progress relative');
            },
            error: function (jqXHR) {
                if (!TINK.redirectIfConflict(jqXHR)) {
                    sectionInProgress.removeClass('in-progress relative');
                }
            }
        });
    });

    $('#search-all-stores-btn').on('click', function () {
        let sectionInProgress = $('.internal.vitrine');
        sectionInProgress.addClass('in-progress relative');
        initializeMap();
        onClickBoxShowMapMarker();
        pushDataLayerSearchStore();
        hideMapPlaceholderToDisplayMap();
        $('.fs--boxes').show();
        $('#mapResults').removeClass('hide').show();
        sectionInProgress.removeClass('in-progress relative');
    });

    $('.fs--city-container li a').click(function () {
        var city = $(this).text();
        $('#city').val(city);
        var $searchCity = $('.fs--btn-search-city');
        $searchCity.text(city);
    });

    $('.view-store-list').on('click', function() {
        $(this).addClass('list-view-active');
        $('.view-store-map').removeClass('list-view-active');
        $('.fs--boxes-shops .fs--box-shop').removeClass('fs--hide');
        $('#search-map-container').addClass('fs--hide');
        $('.showMoreStores').removeClass('fs--hide');
    });
    $('.view-store-map').on('click', function() {
        $(this).addClass('list-view-active');
        $('.view-store-list').removeClass('list-view-active');
        $('.fs--boxes-shops .fs--box-shop').addClass('fs--hide');
        $('#search-map-container').removeClass('fs--hide');
        $('.showMoreStores').addClass('fs--hide');
    });

    $('.fs--boxes').on('click', '.openStoreLocator', function (e) {
        e.preventDefault();
        ServiceTimeslot.openServiceAndTimeslot.bind(this)();
        return false;
    })

    FindStoreHelper.bindFindStore(fsContainerId, true);

    function onClickBoxShowMapMarker() {
        $('find-a-store .fs--box-shop').click(function () {
            let index = parseInt($(this).attr('data-store-index'));
            clickMarkerById(index);
        });
    }

    onClickBoxShowMapMarker();
}

$(document).ready(function () {
    loadGoogleMaps('initFindStore');
});
